import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./Mainlayout";
import { ProfileManagement } from "../components/Profile/ProfileManagement";
import { TalentHomepage } from "../components/talent";
import SignIn from "../pages/Auth/SignIn_updated";
import Register from "../pages/Register/Register";
import { RegisterTalentForm } from "../components/RegisterTalentForm/RegisterTalentForm";
import ForgotPasswordPage from "../pages/Auth/ForgotPassword";
import VerifyEmailPage from "../pages/Auth/VerifyPage";
import PasswordResetPage from "../pages/Auth/ResetPassword";
import withAuthentication from "../hoc/withAuthentication";
import TalentDashboardPage from "../components/Dashboard/TalentDashboard/TalentMainDashboard";
import TalentProfileEdit from "../components/Profile/TalentProfileEdit";
import CreateFlyoverPage from "../components/Dashboard/Talent/Card/TalentCardDesign/TalentCardFlyOver";
import Homepage from "../pages/LandingPage/Home";
import CreateStageCardWrapper from "../components/Stagemode/talents-ui/CreateStageCardWrapper";
import FeaturedEventDetail from "../components/Dashboard/Talent/Card/Featured_Card/FeaturedEventDetail";
import TalentNotification from "./TalentNotification";
import StageMoodBookingList from "../components/Dashboard/TalentDashboard/BookingCard/StageMoodBooking";
import StageCards from "../components/Profile/StageCards_updated";
import AboutPage from "../pages/LandingPage/AboutPage";
import ContactPage from "../pages/LandingPage/contacts/Contactpage";
import TalentHelpPage from "../components/Help/TalentHelpPage";
import TalentSettingsWrapper from "../components/Profile/TalentSettings/TalentSettingWrapper";
import SupportPage from "../components/Support/SupportPage";
import UserTaasnetpage from "../components/Dashboard/User/Homepage/UserTaasnetpage";
import { useCurrentTalentProfile } from "../hooks";
import TalentWalletDashboardNew from "../components/Wallet/Talent/TalentWalletDashboardNew";
import TalentPage from "../pages/Talent/TalentPage";
import ComingSoon from "../pages/LandingPage/ComingSoon";
import BusinessChoiceLanding from "../components/BusinessAccount/Register/BussinessChoiceLanding";
//import { StageLinkTalentPage } from "../components/StageLink/Talent/StagelinkTalentPage_native_2";
//import { StageLinkTalentPage } from "../components/StageLink/Talent/StageLinkTalentPage_native";
import { StageLinkTalentPage } from "../components/StageLink/Talent/StageLinkTalentPage";
import BusinessLayout from "./BusinessLayout";
import useCurrentBusinessInfo from "../hooks/useCurrentBusiness";
import BusinessProfile from "../components/Profile/BusinessProfile";
import { KaraokeCardLiveStreamTalent } from "../components/StageLink/Karaokecard/Agora/NewKaraoketalentstream";
//import { Sing4YouTalentPage } from "../components/StageLink/Sing4You/Sing4YouTalentPage_bug_fixed";
//import { Sing4YouTalentPage } from "../components/StageLink/Sing4You/Sing4YouTalentPage_bug_fixed_PVLC";
import { Sing4YouTalentPage } from "../components/StageLink/Sing4You/Sing4YouTalentPage_bug_fixed_pvlc_lyric";
//import { Sing4YouTalentPage } from "../components/StageLink/Sing4You/Sing4YouTalentPag";


const AuthenticatedLayout = withAuthentication(MainLayout);
const BusinessAuthenticatedLayout = withAuthentication(BusinessLayout);

const TalentRoutes = () => {
  const { currentBusiness } = useCurrentBusinessInfo();
  function TalentEditRedirect() {
    const { currentProfile } = useCurrentTalentProfile();

    if (!currentProfile) return null;
    return (
      <Navigate to={`/talent/profile/edit/${currentProfile.id}`} replace />
    );
  }
  return (
    <Routes>
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/coming-soon" element={<ComingSoon />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/signup/verify-email" element={<VerifyEmailPage />} />
      <Route path="/forgot-password?/OTP" element={<VerifyEmailPage />} />
      <Route path="/home/business-choice" element={<BusinessChoiceLanding />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/support" element={<SupportPage />} />
      <Route path="/home" element={<Homepage />} />
      <Route
        path="/forgot-password/reset-password"
        element={<PasswordResetPage />}
      />
      <Route
        path="/"
        element={
          currentBusiness?.id ? (
            <BusinessAuthenticatedLayout />
          ) : (
            <AuthenticatedLayout />
          )
        }
      >
        <Route
          index
          element={
            currentBusiness?.id ? <BusinessProfile /> : <ProfileManagement />
          }
        />
        <Route path="dashboard" element={<TalentHomepage />} />
        <Route path="TNpage" element={<UserTaasnetpage />} />
        <Route
          path="talent/profile"
          element={
            currentBusiness?.id ? <BusinessProfile /> : <ProfileManagement />
          }
        />
        <Route path="talent-dashboard" element={<TalentDashboardPage />} />
        <Route path="/bookings/stagecard" element={<StageMoodBookingList />} />
        <Route path="/notification" element={<TalentNotification />} />
        <Route path="talent" element={<ProfileManagement />} />
        <Route path="/talent/profile/edit" element={<TalentEditRedirect />} />
        <Route
          path="talent/profile/edit/:talentId"
          element={<TalentProfileEdit />}
        />
        <Route path="create-flyer/:id" element={<CreateFlyoverPage />} />
        <Route path="register-talent" element={<RegisterTalentForm />} />
        <Route path="wallet" element={<TalentWalletDashboardNew />} />
        <Route path="stage-mode" element={<CreateStageCardWrapper />} />
        <Route path="stage-cards" element={<StageCards />} />
        <Route path="featured-event" element={<StageCards />} />

        <Route path="talent/profile/:id" element={<TalentPage />} />
        <Route path="settings" element={<TalentSettingsWrapper />} />

        <Route path="/featured-event/:id" element={<FeaturedEventDetail />} />
        <Route
          path="stage-live-talent/:channel_name"
          element={<StageLinkTalentPage />}
        />
        {/* <Route
          path="stage-link-talent/:channel_name"
          element={<StageLinkTalentPage />}
        /> */}
        <Route path="/help" element={<TalentHelpPage />} />
        <Route path="/talent/karaoke-card" element={<KaraokeCardLiveStreamTalent/>} />
        <Route path="/singforyoulive/:channel_name" element={<Sing4YouTalentPage />} />
        <Route path="*" element={<div>Route not found</div>} />
      </Route>
    </Routes>
  );
};
export default TalentRoutes;
